import { render, staticRenderFns } from "./IntakeScreeningStep.vue?vue&type=template&id=70d197a0"
import script from "./IntakeScreeningStep.vue?vue&type=script&lang=js"
export * from "./IntakeScreeningStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports